import {Component, Injector, OnInit} from '@angular/core';
import {VideoCategoryDto, VideoServiceProxy} from '../shared/service-proxies/service-proxies';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  categorys: VideoCategoryDto[] = [];
  constructor(injector: Injector, private _videoService: VideoServiceProxy) {
  }
  ngOnInit(): void {
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts